import { Spinner, MessageBar, MessageBarType, Link } from '@fluentui/react';
import useAxios from 'axios-hooks';
import React, { useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CoBrandTableAdvisors from '../Components/CoBrandTableAdvisors';

const DefaultPage = () => {
    const [selectedCoBrand, setSelectedCoBrand] = useState(undefined);
    const history = useHistory();
    let { url } = useRouteMatch();

    const [{ data: coBrands, loading }, refetch] = useAxios('internal/cobrand/advisor-settings');

    if (loading) return <Spinner className="absolute-center" label="Loading Cobrand Advisor Settings..." />;

    return (
        <>
            <MessageBar
                styles={{
                    root: {
                        maxWidth: '900px',
                        borderRadius: '4px',
                        fontSize: '15px',
                    }
                }}
            >
                These settings enable the Advisor page in the left navigation menu of the dashboard. 
                The Title and Description fields control the banner content displayed on the page. 
                The On/Off toggle must be set to On for the page to appear. 
                To manage the CTAs that appear on this page, navigate to Call to Action settings at{' '}
                <Link onClick={() => history.push('/cobrand-settings-feature/call-to-action')}>
                    /cobrand-settings-feature/call-to-action
                </Link>.
            </MessageBar>
            <CoBrandTableAdvisors
                cobrands={coBrands && coBrands.length > 0 ? coBrands.sort((a, b) => b.coBrandID - a.coBrandID) : []}
                setSelectedCoBrand={setSelectedCoBrand}
                selectedCoBrand={selectedCoBrand}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                refetch={refetch}
                loading={loading}
            />
        </>
    );
};

export default DefaultPage;
